import { SUPPORT_FORM_URL } from "@utils/constants";
import { EHR_SYNC_GATED_MESSAGE } from "@utils/ehrActions";
import React from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

interface EhrSyncGatedNoticeProps {
  /** Override the leading sentence — e.g. the outbound-sync copy. Defaults to
   * the client-import message. The "Contact support to get started." tail is
   * always appended. */
  message?: string;
}

/**
 * Inline copy explaining why an EHR-touching control is disabled while a
 * tenant's connection is still being cleared for sync. Rendered next to the
 * control itself, never inside a tooltip — a disabled element doesn't
 * receive hover/focus events, so tooltip-only text is unreachable by
 * keyboard/screen reader.
 */
export const EhrSyncGatedNotice: React.FC<EhrSyncGatedNoticeProps> = ({ message = EHR_SYNC_GATED_MESSAGE }) => (
  <Small className="text-limestone-500">
    {message}{" "}
    <a href={SUPPORT_FORM_URL} target="_blank" rel="noreferrer" className="underline">
      Contact support
    </a>{" "}
    to get started.
  </Small>
);
